import { FC } from "react";
import { MobileMenu } from "./MobileMenu"
import { MenuConfiguration } from "./consts";

interface MenuProps {
    collapsed?: boolean;
    onItemSelect?: (itemKey: string) => void;
}

export const Menu: FC<MenuProps> = ({
    collapsed = false,
    onItemSelect,
}) => {
    return (
        <MobileMenu
            collapsed={collapsed}
            items={MenuConfiguration}
            onItemSelect={onItemSelect}
        />
    )
}

export * from './MobileMenu';
export * from './MenuButton';